var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"d-flex flex-row align-center justify-space-between flex-wrap"},[_c('div',{staticClass:"sl-title"},[_vm._v("Work")])]),_c('v-divider',{staticClass:"mt-2 mb-5"}),_c('Weekly')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }